import {
  IBaseResponse,
  IChangePasswordPayload,
  IInitiateExitPayload,
} from "../../../Types/UserProfileDetails";
import ApiService from "../../ApiService";

enum UserServiceEndpoints {
  SEND_RESET_EMAIL = "/send-email",
  CHANGE_PASSWORD = "/reset-password/change-password",
  INITIATE_EXIT = "/initiate-exit",
}

class UserService extends ApiService {
  async sendResetPasswordEmail(email: string): Promise<IBaseResponse> {
    return this.post<IBaseResponse>(UserServiceEndpoints.SEND_RESET_EMAIL, {
      email,
    });
  }

  async changePassword(
    id: number | string,
    passwordPayload: IChangePasswordPayload
  ): Promise<IBaseResponse> {
    return this.post<IBaseResponse>(
      `${UserServiceEndpoints.CHANGE_PASSWORD}/${id}`,
      passwordPayload
    );
  }

  async initiateExit(payload: FormData): Promise<IBaseResponse> {
    return this.post<IBaseResponse>(
      UserServiceEndpoints.INITIATE_EXIT,
      payload
    );
  }
}

export const userService = new UserService();
